module.exports = __webpack_public_path__ + "staticesp/media/marcas (3).5d15ce18.jpg";